import DynamicBackButton from "../backbutton/BackButton"
import { CommonLoader } from "./CommonLoader"

export const CommonHeader = ({title, subTitle, children})=>{
    return(
        <>
        <div className="calculater-header search-filtr">
            <div className="ch-backbtn">
                <DynamicBackButton />
                </div>
                <div className="ch-middlenm txt-center">
                  <h1>{ title }</h1>
                  <p>{ subTitle }</p>
                </div>
                { children }
                <CommonLoader />
              </div>
        </>
    )
}